import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6 max-w-[1440px]">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300/40 text-xs font-medium text-foreground-600 whitespace-nowrap">
            热点分类
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mt-4 leading-tight">
            发现你最关心的吃瓜方向
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-3 max-w-lg mx-auto">
            六大分类频道，从明星八卦到深度解读，总有你感兴趣的那一盘瓜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-6 md:p-7 transition-all duration-300 hover:bg-primary-500 border border-background-200/70 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-background-100 flex items-center justify-center mb-5 group-hover:bg-white/20 transition-colors">
                <i className={`${cat.icon} text-xl text-foreground-700 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-white transition-colors mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 group-hover:text-white/80 transition-colors leading-relaxed">
                {cat.description}
              </p>
              <div className="flex items-center gap-1 mt-4 text-primary-500 group-hover:text-white transition-colors">
                <span className="text-xs font-medium">浏览频道</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}